export const defaultPaginationModel = {
    first: 0,
    page: 1,
    rows: 10,
    sortField: "id",
    sortOrder: 0 as 0 | 1 | -1 | null | undefined, // Explicit casting
  };
  

export class PaginationModel {
    first: number;
    page: number;
    rows: number;
    sortField?: string;
    sortOrder?: 0 | 1 | -1 | null | undefined;
  
    constructor(data = defaultPaginationModel) {
      this.first = data.first;
      this.page = data.page;
      this.rows = data.rows;
      this.sortField = data.sortField;
      this.sortOrder = (data.sortOrder as 0 | 1 | -1 | null | undefined);
    }
  }
  